import navBarArticle from '../modules/navbar-article';
import mobileBottomSocialBar from '../modules/mobile-bottom-social-bar';
import postShareButtons from '../modules/post-share-buttons';
import postAnalytics from '../modules/analytics/post';
import config from '../config';
import slideIndexUtil from '../utils/slideshow_index_util';
import newsletterSignup from '../modules/newsletter_signup';
import imageEnlarger from '../modules/image-enlarger';

let postController = (id, supertag, title, slideIndex) => {
    let slideIndexParam = slideIndexUtil(title, slideIndex);
    const localNewsletterSignup = newsletterSignup('.js-newsletter-form');
    if (config.get('initialPageLoad')) {
        require('../modules/header-slideshow')(slideIndexParam, false);
        require('../modules/inline-slideshow')();
        require('../modules/fc-article-fix')();
        require('../modules/article-video')();
        require('../modules/fc-sharing-popup')();
        // require('../modules/floating-images')();
        require('../modules/reading-bar')();
        // require('../modules/interruptors')();
        require('../modules/media-scaler')();
        // require('../modules/watch-playlist')();
        require('../modules/pym')();
        require('../modules/inline-autoplay-video')();
        require('../modules/custom-content-manager')();
        require('../utils/prose-sanitizer')();
        require('../utils/sidebar_positioning_util')();
        imageEnlarger.on();
        navBarArticle.on();
        mobileBottomSocialBar.on();
        postShareButtons.on();
        localNewsletterSignup.init();
        // map of all avail kinds, method based on kind... match against window.bootstrap.kind
        // window.bootstrap_type = 'post';
        // window.bootstrap_kind = 'longread';
        if (window.bootstrap_kind === 'photoessay') {
            require('../modules/article-slideshow')();
        }
        postAnalytics();
    } else {
       /* eslint-disable no-lonely-if */
        if (config.get('referrer') !== '') {
            window.location = document.referrer;
        } else {
            require('../modules/header-slideshow')(slideIndexParam, true);
        }
    }
};

export default postController;
